import { render } from "./MainEmails.vue?vue&type=template&id=6c1095e1&scoped=true"
import script from "./MainEmails.vue?vue&type=script&lang=js"
export * from "./MainEmails.vue?vue&type=script&lang=js"

import "./MainEmails.vue?vue&type=style&index=0&id=6c1095e1&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1095e1"]])

export default __exports__